/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  AddCarrierNoteRequest,
  AddCarrierNoteResponse,
  AddCarrierRequest,
  AddCarrierSignificantEventRequest,
  AddCarrierSignificantEventResponse,
  CarrierContactSummary,
  CarrierNoteSummary,
  CarrierRegistryEntry,
  CarrierSignificantEventSummary,
} from "../models/index";
import {
  AddCarrierNoteRequestFromJSON,
  AddCarrierNoteRequestToJSON,
  AddCarrierNoteResponseFromJSON,
  AddCarrierNoteResponseToJSON,
  AddCarrierRequestFromJSON,
  AddCarrierRequestToJSON,
  AddCarrierSignificantEventRequestFromJSON,
  AddCarrierSignificantEventRequestToJSON,
  AddCarrierSignificantEventResponseFromJSON,
  AddCarrierSignificantEventResponseToJSON,
  CarrierContactSummaryFromJSON,
  CarrierContactSummaryToJSON,
  CarrierNoteSummaryFromJSON,
  CarrierNoteSummaryToJSON,
  CarrierRegistryEntryFromJSON,
  CarrierRegistryEntryToJSON,
  CarrierSignificantEventSummaryFromJSON,
  CarrierSignificantEventSummaryToJSON,
} from "../models/index";

export interface AddCarrierOperationRequest {
  addCarrierRequest: AddCarrierRequest;
}

export interface AddCarrierNoteOperationRequest {
  addCarrierNoteRequest: AddCarrierNoteRequest;
}

export interface AddCarrierSignificantEventOperationRequest {
  addCarrierSignificantEventRequest: AddCarrierSignificantEventRequest;
}

export interface CarrierRequest {
  carrierIdentifier: string;
}

export interface ContactsRequest {
  carrierIdentifier: string;
}

export interface NotesRequest {
  carrierIdentifier: string;
}

export interface SignificantEventsRequest {
  carrierIdentifier: string;
}

/**
 *
 */
export class CarrierCRMApi extends runtime.BaseAPI {
  /**
   * Register a carrier we have no integration for yet, so a first call can be logged against it. Insert only: the identifier is the carrier\'s permanent key across every \\`carrier_\\*\\` table, so a clash with an existing row is a 409 rather than a silent rewrite of that carrier\'s name and stage. The database decides the clash, so two people adding the same carrier at once get one row and one 409. The identifier is converted to the lowercase letters-and-digits shape integrations use, so a later integration can take the same key without a rename.
   * Register a carrier we have no integration for yet, so a first call can be logged against it.
   */
  async addCarrierRaw(
    requestParameters: AddCarrierOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierRegistryEntry>> {
    if (requestParameters["addCarrierRequest"] == null) {
      throw new runtime.RequiredError(
        "addCarrierRequest",
        'Required parameter "addCarrierRequest" was null or undefined when calling addCarrier().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/add-carrier`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddCarrierRequestToJSON(requestParameters["addCarrierRequest"]),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierRegistryEntryFromJSON(jsonValue),
    );
  }

  /**
   * Register a carrier we have no integration for yet, so a first call can be logged against it. Insert only: the identifier is the carrier\'s permanent key across every \\`carrier_\\*\\` table, so a clash with an existing row is a 409 rather than a silent rewrite of that carrier\'s name and stage. The database decides the clash, so two people adding the same carrier at once get one row and one 409. The identifier is converted to the lowercase letters-and-digits shape integrations use, so a later integration can take the same key without a rename.
   * Register a carrier we have no integration for yet, so a first call can be logged against it.
   */
  async addCarrier(
    requestParameters: AddCarrierOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierRegistryEntry> {
    const response = await this.addCarrierRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Write a note against a carrier. Hubble notes have no Linear comment behind them, so there is nothing to dedupe on and every call creates a new row.
   * Write a note against a carrier.
   */
  async addCarrierNoteRaw(
    requestParameters: AddCarrierNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AddCarrierNoteResponse>> {
    if (requestParameters["addCarrierNoteRequest"] == null) {
      throw new runtime.RequiredError(
        "addCarrierNoteRequest",
        'Required parameter "addCarrierNoteRequest" was null or undefined when calling addCarrierNote().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/add-note`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddCarrierNoteRequestToJSON(
          requestParameters["addCarrierNoteRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AddCarrierNoteResponseFromJSON(jsonValue),
    );
  }

  /**
   * Write a note against a carrier. Hubble notes have no Linear comment behind them, so there is nothing to dedupe on and every call creates a new row.
   * Write a note against a carrier.
   */
  async addCarrierNote(
    requestParameters: AddCarrierNoteOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AddCarrierNoteResponse> {
    const response = await this.addCarrierNoteRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Record a significant event. The same title on the same day is a 409, not a second line.
   * Record a significant event.
   */
  async addCarrierSignificantEventRaw(
    requestParameters: AddCarrierSignificantEventOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<AddCarrierSignificantEventResponse>> {
    if (requestParameters["addCarrierSignificantEventRequest"] == null) {
      throw new runtime.RequiredError(
        "addCarrierSignificantEventRequest",
        'Required parameter "addCarrierSignificantEventRequest" was null or undefined when calling addCarrierSignificantEvent().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/add-significant-event`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: AddCarrierSignificantEventRequestToJSON(
          requestParameters["addCarrierSignificantEventRequest"],
        ),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      AddCarrierSignificantEventResponseFromJSON(jsonValue),
    );
  }

  /**
   * Record a significant event. The same title on the same day is a 409, not a second line.
   * Record a significant event.
   */
  async addCarrierSignificantEvent(
    requestParameters: AddCarrierSignificantEventOperationRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<AddCarrierSignificantEventResponse> {
    const response = await this.addCarrierSignificantEventRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * One carrier\'s registry row, or 404 if it was never curated. The carrier page uses this to render carriers that have no integration code at all, which is most of the board.
   * One carrier\'s registry row, or 404 if it was never curated.
   */
  async carrierRaw(
    requestParameters: CarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<CarrierRegistryEntry>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling carrier().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/carrier`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      CarrierRegistryEntryFromJSON(jsonValue),
    );
  }

  /**
   * One carrier\'s registry row, or 404 if it was never curated. The carrier page uses this to render carriers that have no integration code at all, which is most of the board.
   * One carrier\'s registry row, or 404 if it was never curated.
   */
  async carrier(
    requestParameters: CarrierRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<CarrierRegistryEntry> {
    const response = await this.carrierRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   * Every carrier in the registry --- including ones we never integrated, which is the whole point. Backs the registry dropdown on CRM surfaces.
   * Every carrier in the registry --- including ones we never integrated, which is the whole point.
   */
  async carriersRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierRegistryEntry>>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/carriers`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierRegistryEntryFromJSON),
    );
  }

  /**
   * Every carrier in the registry --- including ones we never integrated, which is the whole point. Backs the registry dropdown on CRM surfaces.
   * Every carrier in the registry --- including ones we never integrated, which is the whole point.
   */
  async carriers(
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierRegistryEntry>> {
    const response = await this.carriersRaw(initOverrides);
    return await response.value();
  }

  /**
   */
  async contactsRaw(
    requestParameters: ContactsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierContactSummary>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling contacts().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/contacts`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierContactSummaryFromJSON),
    );
  }

  /**
   */
  async contacts(
    requestParameters: ContactsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierContactSummary>> {
    const response = await this.contactsRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async notesRaw(
    requestParameters: NotesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierNoteSummary>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling notes().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/notes`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierNoteSummaryFromJSON),
    );
  }

  /**
   */
  async notes(
    requestParameters: NotesRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierNoteSummary>> {
    const response = await this.notesRaw(requestParameters, initOverrides);
    return await response.value();
  }

  /**
   */
  async significantEventsRaw(
    requestParameters: SignificantEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<Array<CarrierSignificantEventSummary>>> {
    if (requestParameters["carrierIdentifier"] == null) {
      throw new runtime.RequiredError(
        "carrierIdentifier",
        'Required parameter "carrierIdentifier" was null or undefined when calling significantEvents().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters["carrierIdentifier"] != null) {
      queryParameters["carrierIdentifier"] =
        requestParameters["carrierIdentifier"];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    const response = await this.request(
      {
        path: `/apollo/carrier-crm/significant-events`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      jsonValue.map(CarrierSignificantEventSummaryFromJSON),
    );
  }

  /**
   */
  async significantEvents(
    requestParameters: SignificantEventsRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<Array<CarrierSignificantEventSummary>> {
    const response = await this.significantEventsRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}
